export const variantTypes = {
  OUTLINED: 'outlined',
  CONTAINED: 'contained',
  STANDARD: 'standard',
  FILLED: 'filled'
}
